/**
 * button interaction
 *
 * @package WPCore
 */

export function initFAQ() {
	const faqItems = document.querySelectorAll('.faq-item');

	faqItems.forEach((item) => {
		item.addEventListener('click', (e) => {
			e.stopPropagation();

			const isOpen = item.classList.contains('active');

			faqItems.forEach((otherItem) => {
				if (otherItem !== item) {
					otherItem.classList.remove('active');
				}
			});

			if (isOpen) {
				item.classList.remove('active');
			} else {
				item.classList.add('active');
			}
		});
	});
}
